export const plansData=[
    {
      name: "BASIC PLAN",
      price: "25",
      features: [
         "2 hours of excercies",
         "Free consultation to teachers",
        "Access to The Community",
    ],  
    },
{
    name: "PREMIUM PLAN",
      price: "30",
      features: [
         "5 hours of excercies",
         "Free consultation to teachers",
        "Access to minibar",
    ],       
},
{
    name: "PRO PLAN",
    price: "40",
    features: [
       "8 hours of excercies",
       "Consultation of Private teachers",
      "Access to The Community",
  ],   
},
];